// import { createTheme } from "@mui/material/styles";

// const theme = createTheme({
//   typography: {
//     fontFamily: "Inter, sans-serif", // default for all components
//     h1: {
//       fontFamily: "Lora, serif",
//     },
//     h2: {
//       fontFamily: "Inter, sans-serif",
//     },
//   },
//   components: {
//     MuiAutocomplete: {
//       styleOverrides: {
//         inputRoot: {
//           fontFamily: "Inter, sans-serif",
//           fontSize: "14px",
//         },
//         option: {
//           fontFamily: "Inter, sans-serif",
//           fontSize: "13px",
//         },
//       },
//     },
//     MuiTextField: {
//       styleOverrides: {
//         root: {
//           fontFamily: "Inter, sans-serif",
//         },
//       },
//     },
//     MuiInputLabel: {
//       styleOverrides: {
//         root: {
//           fontFamily: "Inter, sans-serif",
//         },
//       },
//     },
//     MuiInputBase: {
//       styleOverrides: {
//         input: {
//           fontFamily: "Inter, sans-serif",
//           fontSize: "14px",
//         },
//       },
//     },
//   },
// });

// export default theme;
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "Inter, sans-serif", // default for all components
    h1: {
      fontFamily: "Lora, serif",
    },
    h2: {
      fontFamily: "Inter, sans-serif",
    },
  },
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        inputRoot: {
          fontFamily: "Inter, sans-serif",
          fontSize: "14px",
        },
        option: {
          fontFamily: "Inter, sans-serif",
          fontSize: "13px",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontFamily: "Inter, sans-serif",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: "Inter, sans-serif",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontFamily: "Inter, sans-serif",
          fontSize: "14px",
        },
      },
    },

    // ✅ Responsive Buttons
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          fontFamily: "Inter, sans-serif",
          fontWeight: 400,

          // Responsive font size
          [theme.breakpoints.down("sm")]: {
            fontSize: "0.75rem", // mobile
            padding: "6px 12px",
            borderRadius: "6px",
            width: "100%", // full width on mobile
          },
          [theme.breakpoints.between("sm", "md")]: {
            fontSize: "0.875rem", // tablets
            padding: "8px 16px",
            borderRadius: "8px",
          },
          [theme.breakpoints.up("lg")]: {
            fontSize: "1rem", // desktop
            padding: "4px 10px",
            borderRadius: "10px",
            width: "auto",
          },
        }),
      },
    },
  },
});

export default theme;
